import { Formik } from "formik";

import PictureInput from "../../../../../components/PictureInput";
import { ApiProfile } from "../../../../../types";
import {
  Checkbox,
  CheckboxLabel,
  CheckboxWrapper,
  Field,
  Form,
  Input,
  Label,
  Select,
  SelectOption,
  SubmitButton,
} from "../../../../../components/forms";
import { Logo } from "../../Logo";
import Panel from "../../Panel";
import { Heading, Intro } from "../../Typography";
import useRegisterScreen from "./useRegisterScreen";

type Props = { onRegister: (profile: ApiProfile) => void; isJudge: boolean };

export default function RegisterScreen({ onRegister, isJudge = false }: Props) {
  const { initialValues, onSubmit, schema, email, isParent, introText } =
    useRegisterScreen({
      onRegister,
      isJudge,
    });

  return (
    <Panel>
      <Logo />
      <Heading>Griptonite account</Heading>
      <Intro>{introText}</Intro>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        <Form>
          {isJudge || !isParent ? (
            <Field name="profilePicture" className="text-center">
              <PictureInput />
              {!isJudge && !isParent ? (
                <div style={{ fontSize: 13 }} className="fst-italic">
                  (Optional - will be displayed on leaderboards)
                </div>
              ) : null}
            </Field>
          ) : null}
          <Field name="email">
            <Label>Email address</Label>
            <Input type="email" disabled={!!email} />
          </Field>
          <Field name="password">
            <Label>Password</Label>
            <Input type="password" />
          </Field>
          <Field name="confirmedPassword">
            <Label>Confirm password</Label>
            <Input type="password" />
          </Field>
          <Field name="firstName">
            <Label>{`${isParent ? "Your first name" : "First name"}`}</Label>
            <Input type="text" />
            {isParent ? (
              <small className="text-muted fst-italic">
                Enter your name here, not your child’s!
              </small>
            ) : null}
          </Field>
          <Field name="lastName">
            <Label>{`${isParent ? "Your last name" : "Last name"}`}</Label>
            <Input type="text" />
          </Field>
          {!isParent && !isJudge ? (
            <>
              <Field name="yearOfBirth">
                <Label>Year of birth</Label>
                <Input type="text" inputMode="numeric" />
              </Field>
              <Field name="gender">
                <Label>Gender</Label>
                <Select>
                  <SelectOption value="" disabled defaultValue="" hidden>
                    Select gender...
                  </SelectOption>
                  <SelectOption value="MALE">Male</SelectOption>
                  <SelectOption value="FEMALE">Female</SelectOption>
                  <SelectOption value="OTHER">Other</SelectOption>
                </Select>
              </Field>
            </>
          ) : null}
          <Field name="didAcceptTermsOfUse">
            <CheckboxWrapper>
              <Checkbox />
              <CheckboxLabel className="form-check-label">
                I accept the Griptonite{" "}
                <a
                  href="https://griptonite.io/terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  terms of use
                </a>
              </CheckboxLabel>
            </CheckboxWrapper>
          </Field>
          <Field name="didAcceptPrivacyPolicy">
            <CheckboxWrapper>
              <Checkbox />
              <CheckboxLabel className="form-check-label">
                I accept the Griptonite{" "}
                <a
                  href="https://griptonite.io/terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  privacy policy
                </a>
              </CheckboxLabel>
            </CheckboxWrapper>
          </Field>
          <SubmitButton>Next</SubmitButton>
        </Form>
      </Formik>
    </Panel>
  );
}
